var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner-row extension-conditions-form" },
    [
      _c(
        "el-form",
        {
          ref: "basicForm",
          attrs: { inline: "", "label-position": "left", "label-width": "80px" }
        },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: [
                    "filter_ACTBilling_arCharges",
                    "filter_ACTBilling_apCharges",
                    "filter_ACTBilling_allCharges"
                  ],
                  expression:
                    "['filter_ACTBilling_arCharges','filter_ACTBilling_apCharges','filter_ACTBilling_allCharges']"
                }
              ],
              attrs: { label: _vm.$t("CargoMsg.Cargo_PaymentReceiveMethodP") }
            },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { disabled: _vm.enabledBillType },
                  model: {
                    value: _vm.ownConditions.isAr,
                    callback: function($$v) {
                      _vm.$set(_vm.ownConditions, "isAr", $$v)
                    },
                    expression: "ownConditions.isAr"
                  }
                },
                [
                  _c(
                    "el-radio",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["filter_ACTBilling_arCharges"],
                          expression: "['filter_ACTBilling_arCharges']"
                        }
                      ],
                      attrs: { label: 1 }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Receivable")))]
                  ),
                  _c(
                    "el-radio",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["filter_ACTBilling_apCharges"],
                          expression: "['filter_ACTBilling_apCharges']"
                        }
                      ],
                      attrs: { label: 0 }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Dues")))]
                  ),
                  _c(
                    "el-radio",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["filter_ACTBilling_allCharges"],
                          expression: "['filter_ACTBilling_allCharges']"
                        }
                      ],
                      attrs: { label: -1 }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_All")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: [
                    "filter_ACTBilling_allRegionalCharges",
                    "filter_ACTBilling_overseaCharges",
                    "filter_ACTBilling_localCharges"
                  ],
                  expression:
                    "['filter_ACTBilling_allRegionalCharges','filter_ACTBilling_overseaCharges','filter_ACTBilling_localCharges']"
                }
              ],
              attrs: { label: _vm.$t("CargoMsg.Cargo_ChargeTypeP") }
            },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { disabled: _vm.enabledBillType },
                  model: {
                    value: _vm.ownConditions.oversea,
                    callback: function($$v) {
                      _vm.$set(_vm.ownConditions, "oversea", $$v)
                    },
                    expression: "ownConditions.oversea"
                  }
                },
                [
                  _c(
                    "el-radio",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["filter_ACTBilling_localCharges"],
                          expression: "['filter_ACTBilling_localCharges']"
                        }
                      ],
                      attrs: { label: 0 }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Domestic")))]
                  ),
                  _c(
                    "el-radio",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["filter_ACTBilling_overseaCharges"],
                          expression: "['filter_ACTBilling_overseaCharges']"
                        }
                      ],
                      attrs: { label: 1 }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_International")))]
                  ),
                  _c(
                    "el-radio",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["filter_ACTBilling_allRegionalCharges"],
                          expression: "['filter_ACTBilling_allRegionalCharges']"
                        }
                      ],
                      attrs: { label: -1 }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_All")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessDateP") } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              clearable: false,
                              "value-format": "yyyy-MM-dd",
                              "picker-options": _vm.pickerOptions,
                              disabled: _vm.enabledBillType
                            },
                            model: {
                              value: _vm.ownConditions.businessDate[0],
                              callback: function($$v) {
                                _vm.$set(_vm.ownConditions.businessDate, 0, $$v)
                              },
                              expression: "ownConditions.businessDate[0]"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 1 } }, [
                    _c("span", { staticStyle: { "font-size": "12px" } }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_To")))
                    ])
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              clearable: "",
                              "value-format": "yyyy-MM-dd",
                              "picker-options": _vm.pickerOptions,
                              disabled: _vm.enabledBillType
                            },
                            model: {
                              value: _vm.ownConditions.businessDate[1],
                              callback: function($$v) {
                                _vm.$set(_vm.ownConditions.businessDate, 1, $$v)
                              },
                              expression: "ownConditions.businessDate[1]"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "padding-left": "5px" },
                      attrs: { span: 7 }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "0" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: _vm.enabledBillType },
                              model: {
                                value: _vm.allowTwoyearOutside,
                                callback: function($$v) {
                                  _vm.allowTwoyearOutside = $$v
                                },
                                expression: "allowTwoyearOutside"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("WriteOff.queryLotsOfData")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }